import download from './download';
export default download;